module.exports = __webpack_public_path__ + "img/tile-plus-logo-light-horizontal.1dcf1f3c.svg";